import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/content.styles'
// import Button from '@material-ui/core/Button'
// import RemoveIcon from '@material-ui/icons/Remove';
// import AddIcon from '@material-ui/icons/Add';
import { CaratteristichePageConfig } from '../../configuration';
import FadeInHOC from '../FadeInHOC';
import clsx from 'clsx';
// import SlideUpText from '../../SlideUpText'

const useStyles = makeStyles(styles)

export default function Content({ primaryText, secondaryText, expandedText }) {
    const [textExpanded, setTextExpanded] = useState(false)
    const classes = useStyles()
    return (
        <div className={classes.root} >
            <FadeInHOC rootClass={classes.imgWrap} >
                <img className={classes.image} src={CaratteristichePageConfig.image} alt='flowers' />
            </FadeInHOC>
            <FadeInHOC rootClass={classes.content} >
                <h1 className={classes.h1} dangerouslySetInnerHTML={{__html: primaryText}} />
                <h2 className={clsx(classes.h2, textExpanded && classes.secondaryExpanded)} dangerouslySetInnerHTML={{__html: secondaryText}} />
                {/* <SlideUpText duration='1s' when={textExpanded} rootClass={classes.expanded} >
                    <h2 className={clsx(classes.h2)} >{expandedText}</h2>
                    <Button
                        disableRipple
                        onClick={() => setTextExpanded(!textExpanded)}
                        className={clsx(classes.button, classes.btnExpand)}
                        variant='text'
                        endIcon={<RemoveIcon />}
                    >
                        Nascondi
                    </Button>
                </SlideUpText>
                <Button
                    disableRipple
                    onClick={() => setTextExpanded(!textExpanded)}
                    className={clsx(classes.button, textExpanded && classes.scaleDown)}
                    variant='text'
                    endIcon={<AddIcon />}
                >
                    Scopri di più
                </Button> */}
            </FadeInHOC>
        </div>
    )
}
